@if (error) {
  <div class="p-5">
    <h4 style="color:red" class="">Error - {{error}}</h4>
    <p>{{error_description}}</p>
  </div>
}
